import React, { createElement, useState } from 'react';
import moduleCss from './index.module.scss';
import { Mask } from '@ifeng-fe/lowcode_tool/src/components/Mask'
import { useChip, TYPE_Chip } from '@ifeng-fe/lowcode_tool/src/hooks/useChip'
import { formatChip } from '@ifeng-fe/lowcode_tool/src/method/chip'
import { getThumbnailFromRecommend } from '@ifeng-fe/lowcode_tool/src/method/common'
import { formatImage } from '@ifeng-fe/public_method'
import Chip from 'Chip';

export interface NewsList_6_Props {
    nodeId?: string;
    style?: object;
    newsChip: TYPE_Chip;
}

const NewsList_6: React.FC<NewsList_6_Props> = (props) => {
    const { nodeId, newsChip, style } = props;
    const [currentIndex, setCurrentIndex] = useState(0);

    const chipData = useChip(newsChip);
    const chipComponentData = formatChip(newsChip)

    return (
        <Chip {...chipComponentData}>
            <div id={nodeId} className={moduleCss.tabContent} style={style}>
                <div className={moduleCss.left}>
                    {chipData.map((item, index) => {
                        return (
                            <div
                                className={moduleCss.imageItem}
                                key={index}
                                onClick={() => setCurrentIndex(index)}
                            >
                                <img src={formatImage(getThumbnailFromRecommend(item), 242, 174)} alt="" />
                                <div
                                    className={`${moduleCss.title} ${
                                        currentIndex === index ? moduleCss.active : ''
                                    }`}
                                >
                                    <a href={item.url} target="_blank">
                                        {item.title}
                                    </a>
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className={moduleCss.right}>
                    {chipData[currentIndex] &&
                        chipData[currentIndex].children &&
                        chipData[currentIndex].children.map((item, index) => {
                            return (
                                <div className={moduleCss.news} key={index}>
                                    <div className={moduleCss.title}>
                                        <a href={item.url} target="_blank">
                                            {item.title}
                                        </a>
                                    </div>
                                    <div className={moduleCss.content}>{item.summary}</div>
                                </div>
                            );
                        })}
                </div>
                <Mask visible={!newsChip.id} zIndex={3}>示例推荐位碎片—{newsChip.default.id}</Mask>
            </div>
        </Chip>
    );
};

export default NewsList_6;
